// extracted by mini-css-extract-plugin
module.exports = {"issued":"EmoteDetail_issued__2xW_a"};